import React, { useEffect, useRef, useState } from 'react';
import TreeView from './TreeView';

function TreeFilter({
  ontology,
  includeList,
  excludeList,
  expandedList,
  bubbleUpFilterList,
  bubbleUpExcludeNode,
  bubbleUpExpandedNodes,
  compareLists
}) {
  const [data, setData] = useState([]);
  const [filterParameters, setFilterParameters] = useState(null);
  const [excludeParameter, setExcludeParameters] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState(null);
  const bubbleUpFilterListRef = useRef(bubbleUpFilterList);
  const bubbleUpExcludeNodeRef = useRef(bubbleUpExcludeNode);
  const bubbleUpExpandedNodesRef = useRef(bubbleUpExpandedNodes);

  useEffect(() => {
    bubbleUpFilterListRef.current = bubbleUpFilterList;
  }, [bubbleUpFilterList]);

  useEffect(() => {
    bubbleUpExcludeNodeRef.current = bubbleUpExcludeNode;
  }, [bubbleUpExcludeNode]);

  useEffect(() => {
    bubbleUpExpandedNodesRef.current = bubbleUpExpandedNodes;
  }, [bubbleUpExpandedNodes]);

  useEffect(() => {
    setData(ontology);
  }, [ontology]);

  useEffect(() => {
    if (filterParameters !== null) {
      bubbleUpFilterListRef.current(filterParameters);
    }
  }, [filterParameters]);

  useEffect(() => {
    if (excludeParameter !== null) {
      bubbleUpExcludeNodeRef.current(excludeParameter);
    }
  }, [excludeParameter]);

  useEffect(() => {
    if (expandedNodes !== null) {
      bubbleUpExpandedNodesRef.current(expandedNodes);
    }
  }, [expandedNodes]);

  return (
    <TreeView
      data={data}
      includeList={includeList}
      excludeList={excludeList}
      expandedList={expandedList}
      includeIdSet={new Set(includeList.map(node => node.id))}
      excludeIdSet={new Set(excludeList.map(node => node.id))}
      expandedIdSet={new Set(expandedList.map(node => node.id))}
      onUpdateCb={updatedData => setData(updatedData)}
      onUpdateExclude={excludeNode => setExcludeParameters(excludeNode)}
      onUpdateFilterParameters={updatedFilters => {
        return setFilterParameters(updatedFilters);
      }}
      onUpdateExpanded={expandNode => setExpandedNodes(expandNode)}
      onCheckToggleCb={nodes => {
        const checkState = nodes[0].isChecked;

        applyCheckStateTo(nodes, checkState, 0);

        function applyCheckStateTo(nodes) {
          nodes.forEach(node => {
            node.isChecked = checkState;
          });
        }
      }}
      onDeleteCb={(node, updatedData, depth) => {
        alert(`${node.name} will be deleted`);
        return true;
      }}
    />
  );
}

export default TreeFilter;
